import $ from 'jquery';

import EC from './ExpressionComparator';

class FormValidator{
    constructor(validationFields){
        this.validationFields = validationFields;
    }
    showError(element, msg){
        /*
        var formGroupObj = $(element).parent('.form-group').length > 0 ? $(element).parent('.form-group') : $(element).parent().parent('.form-group');
        formGroupObj.addClass('has-error').find('.error-message').html(msg);
        */

        $('.errorMessage.'+element.id).html(msg);
        $('#'+element.id).addClass('errorShadow');
    }
    showRadioError(element,msg){ // this is only for radio elements
        $('.errorMessage.'+element.id).html(msg);
    }
    showSignatureError(element,msg){ // this is only for radio elements
        $('.errorMessage.'+element.id).html(msg);
    }
    hideError(element){
        /*
        var formGroupObj = $(element).parent('.form-group').length > 0 ? $(element).parent('.form-group') : $(element).parent().parent('.form-group');
        formGroupObj.removeClass('has-error').find('.error-message').html('');
        */

        $('.errorMessage.'+element.id).empty();
        $('#'+element.id).removeClass('errorShadow');
    }
    hideAllErrors(){
        $('.errorMessage').empty();
        $('.errorShadow').removeClass('errorShadow');

    }

    validate(){
        var isValid = true;
        var isLocalValid = true;
        this.validationFields.each((index,obj)=>{
            isLocalValid = this.validateField(obj);
            if(!isLocalValid && isValid){
                isValid = false;
            }
        });
        return isValid;
    }

    validateField(element){

        var comparisonList = $(element).data('validation-list').split(' ');
        var isValid = true;

        comparisonList.forEach((obj)=>{
            if(!isValid) return; // to exit on first error occurrence

            var vs = EC[obj](element.value);
            if(!vs.isValid){
                this.showError(element,vs.msg);
                isValid = false;
            }else{
                this.hideError(element);
            }
        });

        return isValid;
    }
    validateRadioField(element){
        let radio = $('input:radio[name="'+element.id+'"]:checked');
        if(radio.length == 0){
            this.showRadioError(element,'Required');
        }else{
            this.hideError(element);
        }
    }
    validateCheckbox(element){
        let isChecked = $(element).is(':checked');
        let parentElement = $(element).parent()[0];
        if(!isChecked){
            this.showError(parentElement,'Please agree to the terms');
        }else{
            this.hideError(parentElement);
        }
    }
    validateSignatureField(element){
        this.hideError(element);
    }
}

export default FormValidator;



/** WEBPACK FOOTER **
 ** C:/Apache2/htdocs/shutterbabee/contact/controls/FormValidator.js
 **/